import { lazy } from 'react';

export const PlayerSsnForm = lazy(() => import('./PlayerSsnForm'));
